import Firebase from 'firebase/app'
import database from 'firebase/database'
import authentication from 'firebase/auth'

 let config = {
    apiKey: 'AIzaSyBhY32RQaGskrWPC88xPC5od9A7gmKznPo',
    authDomain: 'test-d8181.firebaseapp.com',
    databaseURL: 'https://test-d8181.firebaseio.com/'
  };
let app = Firebase.initializeApp(config)
export const db = app.database()
export const auth = app.auth()
